<script setup lang="ts">
import AppError401 from '@ui/pages/AppError401/index.vue';
import AppError404 from '@ui/pages/AppError404/index.vue';
import AppError from '@ui/pages/AppError/index.vue';

interface Props {
  error: {
    statusCode: number;
    message: string;
  };
}

const props = defineProps<Props>();

const pageByCode = computed(() => {
  switch (props.error?.statusCode) {
    case 401:
      return AppError401;
    case 404:
      return AppError404;
    default:
      return AppError;
  }
});
</script>

<template>
  <NuxtLayout name="empty">
    <div class="flex flex-col items-center justify-center h-full px-0 py-6 max-[444px]:p-0">
      <component
        :is="pageByCode"
        :error="error"
      />
    </div>
  </NuxtLayout>
</template>
